<script>
	import { navigate  } from 'svelte-routing'
    import { ReturnComma } from '../../script/_handle'

    export let Device, List

    function onClickContents(_num) {
        navigate("/detail/" + _num);
    }
</script>

{#await List}
    <div class="issue">
        Data Loadding...
    </div>
{:then listData} 
    {#if listData.length != undefined}
        <div class="list">
            {#if listData.length > 0 && typeof listData == 'object'}
                <table>
                    <tr>
                        <th class='num'>번호</th>
                        <th class='title'>제목</th>
                        {#if Device < 3}
                            <th class='nickname'>닉네임</th>
                            <th class='version'>빌드</th>
                            <th class='date'>작성일시</th>
                        {/if}
                        <th class='view'>조회수</th>
                    </tr>
                    
                    {#each listData as item}
                        <tr on:click={() => onClickContents(item.num)}>
                            <td>{item.num}</td>
                            <td>
                                {item.title}

                                {#if item.testCheck}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <circle cx="8.5" cy="8.5" r="8.5" fill="#7A67FF"/>
                                        <path d="M4.9231 5.40039V4.10156H12.593V5.40039H9.51685V14H8.01294V5.40039H4.9231Z" fill="white"/>
                                  </svg>
                                {/if}
                                
                                {#if item.blankCheck}
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                        <circle cx="8.5" cy="8.5" r="8.5" fill="#7A67FF"/>
                                        <path d="M5 13.8984V4H8.62305C10.7285 4 11.7539 5.13477 11.7539 6.59766C11.7539 7.82812 11.002 8.45703 10.0859 8.68945V8.78516C11.0703 8.83984 12.1367 9.70117 12.1367 11.2324C12.1367 12.75 11.0977 13.8984 8.78711 13.8984H5ZM8.65039 12.6133C10.0723 12.6133 10.6465 11.9844 10.6465 11.1641C10.6465 10.2207 9.89453 9.45508 8.70508 9.45508H6.50391V12.6133H8.65039ZM8.5 8.2793C9.49805 8.2793 10.2773 7.66406 10.2773 6.7207C10.2773 5.90039 9.7168 5.28516 8.52734 5.28516H6.50391V8.2793H8.5Z" fill="white"/>
                                  </svg>
                                {/if}
                            </td>
                            {#if Device < 3}
                                <td>{item.nickname}</td>
                                <td>Build 00{item.build}</td>
                                <td>{item.writeDate}</td>
                            {/if}
                            <td>{item.view}</td>
                        </tr>
                    {/each}
                </table>
            {:else}
                <div class="issue">
                    조회되는 정보가 없습니다.
                </div>
            {/if}
        </div> 
    {/if}
{/await}


<style lang="scss">
    .list {
        width: calc(100%);
        max-width: 1200px;
        height: fit-content;
        margin: auto;
        margin-top: 50px;

        table {
            width: 100%;
            text-align: center;

            tr {
                &:hover {
                    td {
                        background: rgba($color: $cl3, $alpha: 0.4);
                    }
                }
            }

            th, td { padding: 13px 0 10px 0; }

            th {
                background: $cl6;
                font-family: aggro;

                &.num { width: 55px; }
                &.version { width: 100px; }
                /*&.date { width: 95px; }*/
            }

            td {
                border-bottom: 1px solid $cl3;
                cursor: pointer;
            }

            @include mobile { font-size: 12px; }
            @include tablet { font-size: 15px; }
            @include desktop { font-size: 15px; }
            @include wide { font-size: 15px; }
        }
    }
    .issue {
        width: calc(100% - 30px);
        height: fit-content;
        padding: 15px;
        color: $cl4;
        font-size: 20px;
        font-family: aggro;
        text-align: center;
    }
</style>